import {rootAction} from "../apiAction";

export const REQUEST_START_SIGNING = 'REQUEST_START_SIGNING';
export const SUCCESS_START_SIGNING ='SUCCESS_START_SIGNING';
export const FAILURE_START_SIGNING = 'FAILURE_START_SIGNING';

export const CLEAR_SIGNING_STATUS = "CLEAR_SIGNING_STATUS";

export const startSigningProcess = (id, kepId) => dispatch => {
  return dispatch(rootAction(
    'POST',
    `notary/processPackage?id=${id}&kepId=${kepId}`,
    null,
    {
      request: REQUEST_START_SIGNING,
      success: SUCCESS_START_SIGNING,
      failure: FAILURE_START_SIGNING
    }
  ));
};

export const clearSigningStatus = () => ({
  type: CLEAR_SIGNING_STATUS,
});
